import { useFetch } from "../../lib/hooks";
import { StatusBadge } from "../common/Ui";

export function GroupAttendanceRecap({ compact = false }) {
  const { data } = useFetch("/class-groups/attendance-recap");
  if (!data) return null;
  const tone = (p) => (p >= 80 ? "success" : p >= 60 ? "warning" : "danger");
  return (
    <div className="surface p-5" data-testid="group-attendance-recap">
      <div className="flex items-center justify-between mb-3"><h3 className="section-title">Kehadiran per Rombel</h3><span className="text-[11px] text-slate-400">Target ≥ 80%</span></div>
      {data.length === 0 ? <p className="text-sm text-slate-400">Belum ada rombel berisi siswa.</p> : (
        <div className="space-y-2">{data.map((g) => (
          <div key={g.group_id} className="flex items-center gap-3" data-testid="group-recap-row">
            <div className="w-24 shrink-0"><p className="text-sm font-semibold font-heading">{g.name}</p><p className="text-[11px] text-slate-500">{g.students} siswa</p></div>
            <div className="flex-1"><div className="h-2.5 rounded-full bg-slate-100 overflow-hidden"><div className={`h-full rounded-full ${g.percent >= 80 ? "bg-emerald-500" : g.percent >= 60 ? "bg-amber-500" : "bg-red-500"}`} style={{ width: `${Math.min(g.percent, 100)}%` }} /></div>
              {!compact && <p className="text-[11px] text-slate-500 mt-1">H {g.hadir} · I {g.izin} · S {g.sakit} · A {g.alfa} · {g.sessions_done}/{g.sessions_total} sesi berjalan{g.low_students ? <span className="text-red-600"> · {g.low_students} siswa &lt; 80%</span> : ""}</p>}</div>
            <StatusBadge label={g.total ? `${g.percent}%` : "belum ada"} tone={g.total ? tone(g.percent) : "neutral"} />
          </div>))}
        </div>)}
    </div>
  );
}
